interface NoDataStateProps {
  title: string;
  body: string;
  brandColor?: string;
  logoUrl?: string;
}

const isHex = (c?: string) => !!c && /^#[0-9a-fA-F]{6}$/.test(c);

const BagIcon = ({ color }: { color: string }) => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="1.7"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    <rect x="3" y="7.5" width="18" height="12.5" rx="2.5" />
    <path d="M8.5 7.5V6a2.5 2.5 0 0 1 2.5-2.5h2A2.5 2.5 0 0 1 15.5 6v1.5" />
    <path d="M3 12h18" />
  </svg>
);

export function NoDataState({ title, body, brandColor, logoUrl }: NoDataStateProps) {
  const hex = isHex(brandColor) ? brandColor : undefined;
  const tint = hex ?? '#6b7079';
  const squareBg = hex ? hex + '1f' : '#f1f2f4';
  return (
    <div className="flex h-full flex-col items-center justify-center bg-white px-8 text-center">
      {logoUrl && <img src={logoUrl} alt="" className="mb-8 h-12 w-auto object-contain" />}
      <div
        className="flex size-16 items-center justify-center rounded-2xl"
        style={{ background: squareBg }}
      >
        <BagIcon color={tint} />
      </div>
      <div className="mt-6 text-2xl font-extrabold tracking-tight text-[#16171a]">{title}</div>
      <div className="mt-3 max-w-[300px] text-sm leading-relaxed text-[#6b7079]">{body}</div>
    </div>
  );
}
